import React from "react";
import Locked from "../../../../components/userSide/modals/locked";
import { Card, Tooltip } from "antd";
import "./style.css";
import { UnlockOutlined, CheckCircleTwoTone } from "@ant-design/icons";
import LockOutlined from "../../../../Images/locked.png";
import { Link } from "react-router-dom";

const { Meta } = Card;

class MediaCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      courseStatus: null,
      isHovered: false,
    };
  }

  componentDidMount() {
    const { _id } = this.props.course;
    const { courseCompleted } = this.props.user;
    console.log(this.props.firstCourseID);
    this.setState({
      // courseStatus: courseCompleted.includes(_id)
      //   ? "Completed"
      //   : courseCompleted.length === this.props.courseIndex ||
      //     _id === "60183c25f4fcd500242a7d63"
      //   ? "Opened"
      //   : "Locked",
      courseStatus: "Completed",
      // courseStatus: courseCompleted.includes(_id)
      //   ? "Completed"
      //   : courseCompleted.length === 0 && _id === this.props.firstCourseID
      //   ? "Opened"
      //   : courseCompleted.length === this.props.courseIndex
      //   ? "Opened"
      //   : "Locked",
    });
  }

  toggle = () => {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  };

  render() {
    const { _id, courseShortDesc, courseThumbnailImageUrl, courseTitle } =
      this.props.course;

    const { courseStatus, isHovered } = this.state;
    // console.log(isHovered);
    return (
      <div className="grow">
        {courseStatus === "Completed" || courseStatus === "Opened" ? (
          <Link to={`/courses/${_id}`}>
            <Tooltip
              placement="top"
              title={
                "Opened"
                // courseStatus === "Opened" ? "Course Opened" : "Course Completed"
              }
              color={courseStatus === "Opened" ? "black" : "green"}
            >
              {" "}
              <Card
                onMouseEnter={() => this.setState({ isHovered: true })}
                onMouseLeave={() => this.setState({ isHovered: false })}
                onClick={() => {
                  if (
                    courseStatus === "Completed" ||
                    courseStatus === "Opened"
                  ) {
                    this.props.onPageChange({
                      courseID: _id,
                    });
                  } else {
                    this.toggle();
                  }
                }}
                className="mCard"
                hoverable
                style={{ width: 240, height: 280 }}
                cover={
                  <img
                    alt={courseTitle}
                    src={courseThumbnailImageUrl}
                    width="150"
                    height="150"
                  />
                }
              >
                {" "}
                {courseStatus === "Completed" ? (
                  // <CheckCircleTwoTone
                  //   twoToneColor="#52c41a"
                  //   style={{ fontSize: "26px" }}
                  // />.
                  <UnlockOutlined style={{ fontSize: "26px" }} />
                ) : courseStatus === "Opened" ||
                  _id === "60183c25f4fcd500242a7d63" ? (
                  <UnlockOutlined style={{ fontSize: "26px" }} />
                ) : (
                  <img
                    src={LockOutlined}
                    alt="Course Locked"
                    width="26px"
                    title="This Course is Locked"
                  />
                )}
                <br /> <br />
                <Meta
                  title={isHovered === false ? courseTitle : null}
                  description={isHovered === true ? courseShortDesc : null}
                />
              </Card>
            </Tooltip>
          </Link>
        ) : (
          <div>
            <Tooltip placement="top" title="Course Locked" color="red">
              <Locked isOpen={this.state.modal} toggle={this.toggle} />
              <Card
                onClick={() => {
                  this.toggle();
                }}
                onMouseEnter={() => this.setState({ isHovered: true })}
                onMouseLeave={() => this.setState({ isHovered: false })}
                className="mCard"
                hoverable
                style={{ width: 240, height: 280 }}
                cover={
                  <img
                    alt={courseTitle}
                    src={courseThumbnailImageUrl}
                    width="150"
                    height="150"
                  />
                }
              >
                <img
                  src={LockOutlined}
                  alt="Course Locked"
                  width="26px"
                  title="This Course is Locked"
                />
                <br /> <br />
                <Meta
                  title={isHovered === false ? courseTitle : null}
                  description={isHovered === true ? courseShortDesc : null}
                />
              </Card>
            </Tooltip>
          </div>
        )}
      </div>
    );
  }
}

export default MediaCard;
